/* global angular, $, _, Expo */
// Create templates module for ngTemplates to attach to
angular.module('ua5Templates', []);
angular.module('ua5App.home', []);
angular.module('ua5App.single', []);
angular.module('ua5App.resource', []);
angular.module('ua5App.community', []);
angular.module('ua5App.calendar', []);
// Create parent module for application
angular.module('ua5App', [
    'angular-loading-bar',
    'ngTouch',
    'ngResource',
    'ngSanitize',
    'ua5Templates',
    'ui.router',
    'ngAnimate',
    'duScroll',
    'suite',
    'angularModalService',
    'infinite-scroll',
    'ua5App.home',
    'ua5App.single',
    'ua5App.resource',
    'ua5App.community',
    'ua5App.calendar',
    'angulartics',
    'angulartics.google.analytics'
])
    .constant('BREAKPOINTS', {
        MOBILE: 767,
        TABLET: 991,
        LAPTOP: 1199,
        DESKTOP: 1430
    })
    .constant('TRANSITION', {
        // States that require the home content to transition to a smaller
        // state
        STATES: [
            'home.resources',
            'home.community'
        ],
        // Speed of total transition
        DUR: 1.5666,
        EASE: Expo.easeInOut,
        STATEDETAILS: {
            'home.resources': {
                position: 'right'
            },
            'home.community': {
                position: 'left'
            }
        }
    })
    .config(['$locationProvider', '$resourceProvider', function($locationProvider, $resourceProvider) {
        $locationProvider.html5Mode(true);
        $resourceProvider.defaults.stripTrailingSlashes = false;
    }])
    .factory('MetaFactory', [function() {
        var defaults = {
            // Default options / values
            title: 'UCLA Arts: School of the Arts and Architecture',
            description: 'Introduction by the Dean, calendar of events, admissions information and student services.',
            image: location.protocol + '//di79x7a4whson.cloudfront.net/assets/img/ucla-arts-share-img.jpg',
            ogUrl: window.location.href,
            prefix: '',
            suffix: ' | UCLA Arts'
        };
        var meta = {};
        meta = angular.extend({}, defaults, meta);
        function strip(html) {
            var tmp = document.createElement('DIV');
            tmp.innerHTML = html.replace(/['"]+/g, '');
            return tmp.textContent || tmp.innerText || '';
        }
        return {
            meta: meta,
            set: function(src) {
                var cleanedSrc = {};
                angular.forEach(src, function(value, key) {
                    cleanedSrc[key] = strip(value);
                });
                angular.forEach(defaults, function(value, key) {
                    if (!cleanedSrc.hasOwnProperty(key)) {
                        cleanedSrc[key] = value;
                    }
                });
                meta = _.extend(meta, defaults, cleanedSrc);
            }
        };
    }])
    .controller('MetaCtrl', ['MetaFactory', '$scope', function(MetaFactory, $scope) {
        $scope.$watch(function() {
            return MetaFactory.meta;
        }, function(obj) {
            $scope.meta = obj;
        }, true);
    }])
    .run(['FacebookService', '$location', '$rootScope', function(FacebookService, $location, $rootScope) {
        var DEVELOPMENT_HOST = '127.0.0.1';
        var appPath;
        var fbId;
        // Switch FB ID based on host
        switch ($location.host()) {
            // Staging
            case 'staging.uclaarts.com':
                fbId = '908449005913653';
                break;
            // Production
            case 'www.uclaarts.com':
                fbId = '908448322580388';
                break;
            // Development environment
            default:
                fbId = '908448605913693';
                break;
        }
        FacebookService.init(fbId);
        // Set up the `apiDevUrl` to be prepended to all API routes
        appPath = $location.host() === DEVELOPMENT_HOST ? 'app_dev.php' : 'app.php';
        $rootScope.apiDevUrl = '/' + appPath + '/api/';
    }])
    .directive('app', ['$rootScope', '$location', '$window', 'MetaFactory', function($rootScope, $location, $window, MetaFactory) {
        return {
            link: function($scope, $element, $attrs) {
                var $$window = $(window);
                $$window.on('resize', _.throttle(function() {
                    $rootScope.$broadcast('app:resized');
                }, 250));
                $$window.on('click', function(e) {
                    $rootScope.$broadcast('app:clicked', e.target);
                });
                $$window.on('scroll', _.throttle(function(e) {
                    $rootScope.$broadcast('app:scrolled');
                }, 250));
                $$window.on('keydown', function(e) {
                    var keyCode;
                    var letter;
                    keyCode = e.keyCode;
                    // Escape key
                    if (keyCode === 27) {
                        $scope.$broadcast('app:escapePressed');
                    } else if (keyCode === 13) {
                        $scope.$broadcast('app:enterPressed');
                    } else if (
                        !e.metaKey &&
                        !e.ctrlKey &&
                        (keyCode > 64 && keyCode < 91)
                    ) {
                        letter = String.fromCharCode(keyCode);
                        $scope.$broadcast('app:letterPressed', letter);
                    }
                });
                $scope.$on('$stateChangeSuccess', function(event, toState) {
                    $$window.scrollTop(0);
                    $rootScope.$state = toState;
                });

                $scope.$on('$stateChangeStart', function(event) {
                    MetaFactory.set({
                        suffix: ''
                    });
                });
            }
        };
    }])
;
